// Configuración de API para diferentes entornos.
// En producción depende exclusivamente de REACT_APP_API_URL — sin fallback hardcodeado.
const resolveBaseURL = () => {
  const environment = process.env.NODE_ENV || "development";
  if (environment !== "production") {
    return "http://localhost:8000";
  }
  const url = process.env.REACT_APP_API_URL;
  if (!url) {
    // eslint-disable-next-line no-console
    console.error(
      "[ITSatApp] REACT_APP_API_URL no está configurada. " +
        "Agrégala en Vercel → Settings → Environment Variables y haz redeploy.",
    );
  }
  return url || "";
};

export const API_BASE_URL = resolveBaseURL();

const API_CONFIG = {
  development: { baseURL: "http://localhost:8000" },
  production: { baseURL: API_BASE_URL },
};

// Helper para construir URLs de API
export const buildApiUrl = (endpoint) => {
  return `${API_BASE_URL}${endpoint}`;
};

// URLs específicas más usadas
export const API_ENDPOINTS = {
  current: "/api/sessions/current",
  surveys: "/api/surveys",
  surveyResponses: "/api/survey-responses",
  surveyResponsesFull: "/api/survey-responses-full",
  organizations: "/api/organization",
  login: "/api/sessions/login",
  register: "/api/users/register",
  sessionRegister: "/api/sessions/register",
  logout: "/api/sessions/logout",
  contacts: "/api/contacts",
  users: "/api/users",
  usersOrg: "/api/users/org",
  resetPassword: "/api/auth/reset-password",
  forgotPassword: "/api/auth/forgot-password",
  closeStudies: "/api/surveys/close-studies",
  activateStudies: "/api/surveys/activate-studies",
  measurementVisibility: "/api/surveys/measurement-visibility",
  getAllHistorics: "/api/surveys/historic-all",
  surveysContactsStatus: "/api/surveys/contacts-status",
  surveysSendBatch: "/api/surveys/send-batch",
  surveysScheduleCommunication: "/api/surveys/schedule-communication",
  surveysUnscheduleCommunication: "/api/surveys/unschedule-communication",
  surveysGetScheduledCommunications: "/api/surveys/scheduled-communications",
  surveysUpdatePlanningDates: "/api/surveys/planning-dates",
  surveysRescheduleCommunication: "/api/surveys/reschedule-communication",
  surveysContactWarning: "/api/surveys/contact-warning",
  apiCallsStats: "/api/api-calls/stats",
  changePassword: "/api/users/change-password",
  sendEmail: "/api/email/send-status",
  RESULTS: "/api/results",
  GENERATE_INFORME: "/api/results/generate-informe",
  SERVICIOS: "/api/servicios",
  PREGUNTAS: "/api/preguntas",
  RECOMMENDATIONS: "/api/recommendations",
  BENCHMARK: "/api/benchmark",
  BENCHMARK_YEARS: "/api/benchmark/years",
  BENCHMARK_SECTORS: "/api/benchmark/sectors",
  ORGANIZATION_UPDATE: "/api/organization",
  setPassword: "/api/auth/set-password",
  verifyEmail: "/api/auth/verify-email",
  resendVerification: "/api/auth/resend-verification",
  usersPending: "/api/users/pending",
  mfaSetup: "/api/auth/mfa/setup",
  mfaVerifySetup: "/api/auth/mfa/verify-setup",
  mfaValidate: "/api/auth/mfa/validate",
  impersonationStart: "/api/admin/impersonation/start",
  impersonationStop:  "/api/admin/impersonation/stop",
  resendInvitation: "/api/users",
  homeVideos: "/api/home-videos",
};

export const APP_DISPLAY_NAME = "IT SAT CETIUC® APP";

export default API_CONFIG;
